"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateKey = void 0;
var Signature_1 = require("./Signature");
var PublicKey_1 = require("./PublicKey");
var PrivateKey = /** @class */ (function () {
    function PrivateKey(pair) {
        this.pair = pair;
        if (!pair.compressed) {
            throw new Error('only compressed key is supported');
        }
    }
    PrivateKey.prototype.sign = function (msg) {
        return new Signature_1.Signature(this.pair.sign(msg));
    };
    PrivateKey.prototype.getPublicKey = function () {
        return PublicKey_1.PublicKey.deserialize(this.pair.getPublicKeyBuffer());
    };
    return PrivateKey;
}());
exports.PrivateKey = PrivateKey;
//# sourceMappingURL=PrivateKey.js.map